import React from 'react';
import Crousel from '../page/Crousel';
import Testimonials from './Testimonial';
import Numberofdata from './NumberofData';
import el from '../assests/newurban/Img/ele.avif';
import pl from '../assests/newurban/Img/plumbing-585658_640.jpg';
import carpen from '../assests/newurban/Img/carpentry.jpg';
import wed from '../assests/newurban/Img/welding-work-with-metal-construction-busy-metal-factory.jpg';
import int from '../assests/newurban/Img/inte.avif';
import repair from '../assests/newurban/Img/AMC-Air1.jpg';
import weding from '../assests/newurban/Img/wedding-background-x6ra967epnzel22v.jpg';
import apliances from '../assests/newurban/Img/kitchen-appliances (1).jpg';
import home from '../assests/newurban/Img/home.jpg';
import it from '../assests/newurban/Img/it.png';
import Brand from '../component/Brand';
import Housecleaning from '../assests/homecleaner5.jpg';

export default function LandingPage() {
  const services = [
    { title: 'Electrical Work', image: el, href: '/electricalwork' },
    { title: 'Plumbing Work', image: pl, href: '/plumbingwork' },
    { title: 'Carpentry', image: carpen, href: '/carpentrywork' },
    { title: 'Welding', image: wed, href: '/weldingwork' },
    { title: 'Interior Designing', image: int, href: '/interiordesignwork' },
    {
      title: 'Repair & Installation',
      image: repair,
      href: '/repairandinstallwork',
    },
    { title: 'Wedding Planning', image: weding, href: '/weddingplannerwork' },
    { title: 'Appliances Repair', image: apliances, href: '/applianceswork' },
    { title: 'Construction', image: home, href: '/constructionwork' },
    { title: 'IT Services', image: it, href: '/itservices' },
    { title: 'House Cleaning', image: Housecleaning, href: '/mapform' },
  ];

  return (
    <>
      <div className="mx-auto w-full">
        <Crousel />
        <div id="/services" className="mb-4 text-center mt-8">
          <h2 className="text-2xl md:text-3xl font-semibold text-black uppercase">
            Our Services
          </h2>
          <p className="text-md md:text-lg text-gray-600 font-normal px-2">
            Fast & Affordable Home Services,
            <span className="md:flex md:justify-center px-0.5">
              Get expert services for a variety of needs, all at your doorstep.
            </span>
          </p>
        </div>
        <div className="grid grid-cols-2 gap-6 my-4 lg:my-8 px-4 lg:px-20 lg:grid-cols-4">
          {services.map(service => (
            <a
              key={service.title}
              href={service.href}
              className="flex flex-col items-center bg-white shadow-lg rounded-lg overflow-hidden transform transition-transform duration-300 hover:scale-105"
            >
              <img
                srcSet={`${service.image}?w=400 400w, ${service.image}?w=800 800w`}
                sizes="(max-width: 600px) 400px, 800px"
                src={service.image}
                alt={service.title}
                className="object-cover object-center w-full h-28 md:h-48" // Adjust heights here
                loading="lazy"
              />
              <div className="p-1 text-center">
                <h3 className="text-sm md:text-lg font-semibold text-gray-600 mb-3">
                  {service.title}
                </h3>
              </div>
            </a>
          ))}
        </div>
      </div>
      <Numberofdata />
      <Brand />
      <Testimonials />
    </>
  );
}
